export enum VoReportPermissions {
  VoReport = 'vo-report',
  MboReport = 'mbo-report',
  TransferVoVsDDDReport = 'transfer-vo-vs-ddd-report',
  TransferReport = 'transfer-report',
}
